import { useState } from 'react'

import { cn } from '@/lib/utils/cn'
import { env, resolveApiUrl } from '@/lib/env'

import styles from './BrandLockup.module.css'

interface BrandLockupProps {
  /** Product name. Defaults to the configured workspace name. */
  name?: string
  /** Tenant underneath — white-label studios each have their own. */
  tenant?: string
  /** The workspace's logo, from the session. Falls back to the mark when absent or broken. */
  logoUrl?: string | null
  size?: 'sm' | 'md'
  /** `inverse` for dark grounds, such as the workspace nav. */
  variant?: 'default' | 'inverse'
  /** The sign-in screen uses the bars; the workspace shell uses the dots. */
  mark?: 'bars' | 'dots'
  className?: string
}

export function BrandLockup({
  name = env.appName,
  tenant,
  logoUrl,
  size = 'md',
  variant = 'default',
  mark = 'bars',
  className,
}: BrandLockupProps) {
  const [failedUrl, setFailedUrl] = useState<string | null>(null)
  const showLogo = Boolean(logoUrl) && logoUrl !== failedUrl

  return (
    <div
      className={cn(
        styles.lockup,
        styles[size],
        variant === 'inverse' && styles.inverse,
        className,
      )}
    >
      {showLogo && logoUrl ? (
        <img
          className={styles.logo}
          src={resolveApiUrl(logoUrl)}
          alt=""
          onError={() => setFailedUrl(logoUrl)}
        />
      ) : (
        <span className={mark === 'dots' ? styles.dots : styles.mark} aria-hidden="true">
          <span />
          <span />
          <span />
        </span>
      )}
      <span className={styles.text}>
        <strong className={styles.name}>{name}</strong>
        {tenant && <small className={styles.tenant}>{tenant}</small>}
      </span>
    </div>
  )
}
